/* eslint-disable camelcase */
import axios from '@fs/zion-axios'
import { getAnonSession, clearSessionIdCache } from '@fs/zion-session'
import setCookie from '../../../shared/helpers/cookie'

export const refreshAzureBearerToken = () => {
  return axios
    .post(
      `https://discoveryplatformweb.azurewebsites.net/token`,
      'client_id=3DB08126-A012-40DE-8184-2A9AD65300EE&client_secret=SuperSecret&grant_type=client_credentials',
      { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
    )
    .then((res) => {
      const updatedBearer = {
        // eslint-disable-next-line camelcase
        access_token: res?.data?.access_token,
        ts_created: new Date().getTime(),
      }
      localStorage.setItem('FS.ds-bearerToken', JSON.stringify(updatedBearer))
      return updatedBearer
    })
}
export const getAzureBearerToken = (hasRepeated) => {
  const prom = new Promise((resolve) => {
    const timeNow = new Date().getTime()
    const azureBearer = JSON.parse(localStorage.getItem('FS.ds-bearerToken'))
    let tokenDuration = 0
    if (azureBearer) {
      tokenDuration = timeNow - azureBearer.ts_created
    }
    if (!azureBearer?.access_token || tokenDuration > 82800 * 1000) {
      refreshAzureBearerToken().then(
        (updatedBearer) => {
          resolve(updatedBearer)
        },
        () => {
          if (!hasRepeated) {
            setTimeout(() => {
              resolve(getAzureBearerToken(true))
            }, 500)
          }
        }
      )
    } else {
      resolve(azureBearer)
    }
  })
  return prom
}

export const getDiscoveryUserFromAzure = async (azureSessionId) => {
  const bearerToken = await getAzureBearerToken()
  const url = `https://discoveryplatformweb.azurewebsites.net/api/discoveryusers/${azureSessionId}`
  const headers = {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${bearerToken?.access_token}` },
  }
  return axios
    .get(url, headers)
    .then((res) => {
      const authData = { ...res.data, bearerToken }
      return authData
    })
    .catch((err) => err)
}

export const getDetailedDiscoveryUserFromAzure = (bearerToken, azureSessionId) => {
  const url = `https://discoveryplatformweb.azurewebsites.net/api/family/user/${azureSessionId}`
  const headers = {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${bearerToken?.access_token}` },
  }
  return axios
    .get(url, headers)
    .then((res) => {
      return res.data
    })
    .catch((err) => err)
}

export const authorizeAzureUser = async (azureSessionId) => {
  return getDiscoveryUserFromAzure(azureSessionId)
}

export const getAdditionalAzureDetails = ({ azureSessionId, azureBearerToken, dispatch }) => {
  getDetailedDiscoveryUserFromAzure(azureBearerToken, azureSessionId).then((data) => {
    const userDetails = {
      firstName: data.firstName,
      lastName: data.lastName,
      birthYear: data.birthDate,
      azureSessionId,
      authenticated: !!data.pid,
    }

    dispatch({
      type: 'POPULATE_NONSTANDARD_USER',
      data: { nonstandardUser: { ...userDetails } },
    })
  })
}

export const processPostDockRequests = ({ azureSessionId, dispatch }) => {
  authorizeAzureUser(azureSessionId).then((auth) => {
    if (!auth.authenticated) {
      getAnonSession().then(() => {
        // getAnonSession will set an fssession id to the cookies
        getAdditionalAzureDetails({
          azureBearerToken: auth.bearerToken,
          azureSessionId,
          dispatch,
        })
      })
    } else {
      clearSessionIdCache() // We don't want axios to use any old cached session ids
      setCookie('fssessionid', auth.accessToken)
      getAdditionalAzureDetails({
        azureBearerToken: auth.bearerToken,
        azureSessionId,
        dispatch,
      })
    }
  })
}
